import React, { useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import configs from "../Constants";
import { Radio } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import CircularProgress from "@mui/material/CircularProgress";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
function Gallery({ onSelectImage, foodName }) {
  let baseURL = configs.baseURL;
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(true);
  // Mojahid
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuery, setSearchQuery] = useState(foodName||"");
  const [currentPage2, setCurrentPage2] = useState(1);
  const [isUploading, setIsUploading] = useState(false);

  const uploadFile = (file) => {
    if (!file) return;
    setIsUploading(true);
    let fileName = "pro_" + new Date().getTime() + file.name.replace(/\s+/g, "");
    var formData = new FormData();
    formData.append("uploader", file, fileName);
    let postQueriesUrl = baseURL + "/api/upload/INVENTORY_ITEM";
    
    axios.post(postQueriesUrl, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then(res => {
      let newImgObj = {
        name: fileName,
        image: `${configs.staticSer}/INVENTORY_ITEM/${fileName}`
      };
      handleImageSelect(newImgObj);
      getImages();
      setIsUploading(false);
    }).catch(err => {
      console.error(err);
      setIsUploading(false);
    });
  };

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      uploadFile(e.dataTransfer.files[0]);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleFileInput = (e) => {
    if (e.target.files && e.target.files[0]) {
      uploadFile(e.target.files[0]);
    }
  };

  const handleDelete = (imageObj) => {
    const parts = imageObj.image.split('/');
    const filename = parts[parts.length - 1];
    const pathcodeParam = parts[parts.length - 2] || "INVENTORY_ITEM";
    
    axios.delete(`${baseURL}/api/upload/${pathcodeParam}/${filename}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` }
    })
    .then(res => {
      setImages(images.filter(img => img.image !== imageObj.image));
    })
    .catch(err => {
      console.error("Error deleting image:", err);
    });
  };

  const getImages = (searchText="") => {
    axios
      .get(baseURL+"/api/products/images?foodname="+(searchText.toLowerCase()||searchQuery.toLowerCase()))
      .then((response) => {
        console.log(response.data);
        setImages(response.data);
        setTotalPages(Math.ceil(response.data.length / 10));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching images:", error);
        setLoading(false);
      });
  }
  useEffect(() => {
    getImages();
  }, []);
  console.log("images", images);
  const handleImageSelect = (image) => {
    setSelectedImage(image);
    onSelectImage(image);
  };

  // Mojahid
  // const filteredImages = images.filter((image) =>
  //   image.name.toLowerCase().includes(searchQuery.toLowerCase())
  // );
  const totalPages3 = Math.ceil(images.length / 10);
  //Mojahid added
  const itemsPerPage2 = 10;
  const startIndex2 = (currentPage2 - 1) * itemsPerPage2;
  const endIndex2 = startIndex2 + itemsPerPage2;
  const filteredImagesPerPage = images.slice(startIndex2, endIndex2);

  const preDisable2 = currentPage2 === 1;
  const nextDisable2 = currentPage2 === totalPages3;

  const handleNextClick2 = () => {
    if (currentPage2 < totalPages3) {
      setCurrentPage2(currentPage2 + 1);
    }
  };

  const handlePrevClick2 = () => {
    if (currentPage2 > 1) {
      setCurrentPage2(currentPage2 - 1);
    }
  };

  /////////////////////////////
  const handleNextClick = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

   const handleSearch = () => {
    console.log('newQery',document.getElementById('searchIp'));
    setSearchQuery(document.getElementById('searchIp').value);
    getImages(document.getElementById('searchIp').value);
  };

  const handlePrevClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const preDisable = currentPage === 1;
  const nextDisable = currentPage === totalPages;

  const itemsPerPage = 10;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const itemsToDisplay = images.slice(startIndex, endIndex);
  console.log("itemsToDisplay",itemsToDisplay);

  return (
    <div>
      <div
              className="header"
              style={{
                flex: "0 0 auto",
                padding: "8px",
                borderBottom: "1px solid #ccc",
                position: "sticky",
                top: "0",
                backgroundColor: "#fff",
                zIndex: "1",
                justifyContent: "space-evenly",
              }}
            >  
              <div
                className="search"
                style={{ display: "flex", alignItems: "center" }}
              >
                <SearchIcon />
                <input
                  type="text"
                  placeholder="Search item image"
                  id="searchIp"
                  style={{
                    border: "none",
                    outline: "none",
                    width: "100%",
                    backgroundColor: "transparent",
                    marginLeft: "8px",
                  }}
                  defaultValue={searchQuery}
                />
              </div>
              <Button
                style={{
                  border: "1px solid black",
                  borderRadius: "15px",
                  marginLeft: "5px",
                  padding: "5px 15px",
                  cursor: "pointer",
                  backgroundColor: "#000",
                  color: "#fff",
                }}
                onClick={handleSearch}>Find
              </Button>
            </div>
      <div
              className="content"
              style={{ flex: "1 1 auto", overflowY: "auto", padding: "8px" }}
            >
            <div
              className="upload-zone"
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              style={{
                padding: "20px",
                margin: "10px 0",
                border: "2px dashed #ccc",
                borderRadius: "10px",
                textAlign: "center",
                backgroundColor: "#f9f9f9",
                cursor: "pointer",
                color: "#666"
              }}
              onClick={() => document.getElementById("galleryUploadInput").click()}
            >
              <input 
                type="file" 
                id="galleryUploadInput" 
                style={{ display: "none" }} 
                onChange={handleFileInput} 
                accept="image/*"
              />
              {isUploading ? "Uploading..." : "Drag & Drop Image Here or Click to Upload"}
            </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {searchQuery.length == "" ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <>
              <NavigateBeforeIcon
                onClick={handlePrevClick}
                disabled={preDisable}
                style={{ cursor: "pointer" }}
              />

              <span>
                {currentPage} of {totalPages}
              </span>
              <NavigateNextIcon
                onClick={handleNextClick}
                disabled={nextDisable}
                style={{ cursor: "pointer" }}
              />
            </>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <NavigateBeforeIcon
              onClick={handlePrevClick2}
              disabled={preDisable2}
              style={{ cursor: "pointer" }}
            />

            <span>
              {currentPage2} of {totalPages3}
            </span>

            <NavigateNextIcon
              onClick={handleNextClick2}
              disabled={nextDisable2}
              style={{ cursor: "pointer" }}
            />
          </div>
        )}
      </div>
      {!searchQuery.length ? (
        <>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {itemsToDisplay.map((image, index) => (
              <div
                key={index}
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "150px",
                }}
              >
                <Radio
                  color="primary"
                  checked={selectedImage?.image === image.image || selectedImage === image}
                  onChange={() => handleImageSelect(image)}
                  style={{ position: "absolute", top: 0, left: 0, zIndex: 2 }}
                />
                <IconButton 
                  onClick={() => handleDelete(image)}
                  style={{ position: "absolute", top: 0, right: 0, color: "red", zIndex: 2 }}
                  size="small"
                >
                  <DeleteIcon />
                </IconButton>
                <img
                  src={`${image.image}`}
                  alt={image.name}
                  onError={(e) => {
                    e.target.src = "/images/blank.jpg";
                  }}
                  width="150px"
                  height="150px"
                  style={{ padding: "10px" }}
                />
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          {loading ? (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          ) : filteredImagesPerPage.length === 0 ? (
            <div>No images found</div>
          ) : (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              {filteredImagesPerPage.map((image, index) => (
                <div
                  key={index}
                  style={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "150px",
                    height: "150px",
                    border: "1px solid #ccc",
                    borderRadius: "5px"
                  }}
                >
                  <Radio
                    color="primary"
                    checked={selectedImage?.image === image.image || selectedImage === image}
                    onChange={() => handleImageSelect(image)}
                    style={{ position: "absolute", top: 0, left: 0, zIndex: 2 }}
                  />
                  <IconButton 
                    onClick={() => handleDelete(image)}
                    style={{ position: "absolute", top: 0, right: 0, color: "red", zIndex: 2 }}
                    size="small"
                  >
                    <DeleteIcon />
                  </IconButton>
                  <img
                    src={`${image.image}`}
                    alt={image.name}
                    onError={(e) => {
                      e.target.src = "/images/blank.jpg";
                    }}
                    width="150px"
                    height="150px"
                    style={{ padding: "10px" }}
                  />
                </div>
              ))}
            </div>
          )}
        </>
      )}
      </div>
    </div>
  );
}

export default Gallery;
